import { TextField } from '@mui/material'
import React from 'react'
import { usePostVendorByTaxMutation } from '../../store/api/vendorApi'
import { useState } from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { showTaxDialog } from '../../store/slice/dialogSlice'

function TaxId({ setCompanyName, error, helperText, required, handleInputChange, setTax, tax, disabled, setVendorId }) {
  const dispatch = useDispatch()

  const { t } = useTranslation('register')
  const [defaultValue, setDefaultValue] = useState("")

  const handleBlur = (e) => {
    setTax && setTax(e.target.value)
    postVendorByTax(e.target.value)

    const syntheticEvent = {
      target: {
        name: 'taxId',
        value: e.target.value,
        type: 'textBox',
      },
    }
    handleInputChange && handleInputChange(syntheticEvent)
  }

  const handleChange = (e) => {
    setDefaultValue(e.target.value)
    setTax && setTax(e.target.value)
    const syntheticEvent = {
      target: {
        name: 'taxId',
        value: e.target.value,
        type: 'textBox',
      },
    }
    handleInputChange && handleInputChange(syntheticEvent)
    // postVendorByTax(e.target.value)
  }

  useEffect(() => {
    setDefaultValue(tax)
  }, [tax])


  const [postVendorByTax, { data, isLoading }] = usePostVendorByTaxMutation()

  useEffect(() => {
    if (!isLoading && data) {
      setVendorId && setVendorId(data?.vendorId)
      setCompanyName && setCompanyName(data?.vendorName)
      if (data?.vendorName !== '' && data?.vendorName !== null) {
        dispatch(showTaxDialog())
      }
    } else {
      setVendorId && setVendorId(0)
      setCompanyName && setCompanyName('')
    }
  }, [data])


  return (
    <div>
      <TextField
        required={required}
        helperText={helperText}
        error={error}
        label={t('taxId')}
        disabled={disabled}
        value={defaultValue}
        onChange={handleChange}
        onBlur={handleBlur}
        size="small"
        fullWidth
        inputProps={{ style: { background: disabled ? '#f5f5f5' : "transparant" } }}
      />
    </div>
  )
}

export default TaxId






